import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';

interface UiButtonSignature {
  Args: {
    type?: HTMLButtonElement['type'];
  };
  Blocks: {
    default: [];
  };
  Element: HTMLButtonElement;
}

export default <template>
  <button class="ui-button" type={{or @type "button"}} ...attributes>
    {{yield}}
  </button>
</template> satisfies TOC<UiButtonSignature>;
